module.exports = __webpack_public_path__ + "f8651d03115bbf4e43a628867231fd5c.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PromotionBlock/images/promotion_image2.png
// module id = 1484
// module chunks = 3